import { Figure } from '@/components/Figure'
import { ProgressRing } from '@/components/ProgressRing'
import { getExercise } from '@/data/exercises'
import type { IntervalsPhase } from '@/domain/workout'
import { cx } from '@/lib/cx'
import { ss } from '@/lib/format'
import type { PhaseRuntime } from './usePhaseRunner'
import styles from './workout.module.css'

interface IntervalViewProps {
  phase: IntervalsPhase
  runtime: PhaseRuntime
}

/** Trabajo por tiempo: la figura manda y el número solo confirma. */
export function IntervalView({ phase, runtime }: IntervalViewProps) {
  const { position } = runtime
  if (!position) return null

  const { step } = position
  const resting = step.kind === 'rest'
  const exercise = getExercise(resting ? step.nextExerciseId : step.exerciseId)

  return (
    <div className={cx(styles.work, styles.workCentered)}>
      <ProgressRing
        progress={position.stepProgress}
        overall={runtime.overall}
        resting={resting}
        center="inset"
      >
        {!resting && <Figure exerciseId={step.exerciseId} accent />}
      </ProgressRing>

      <div className={styles.status}>
        {resting ? (
          <>
            <div className={cx(styles.statusLabel, styles.statusResting)}>
              Descanso · Ronda {step.round} de {phase.rounds}
            </div>
            <div className={cx(styles.statusName, styles.statusNameResting)}>Descanso</div>
            <div className={styles.statusNext}>Siguiente · {exercise.name}</div>
          </>
        ) : (
          <>
            <div className={styles.statusLabel}>
              Ronda {step.round} de {phase.rounds} · {step.indexInRound + 1} de {phase.pattern.length}
            </div>
            <div className={styles.statusName}>{exercise.name}</div>
            <div className={styles.statusNext}>{exercise.nameEs}</div>
          </>
        )}
      </div>

      <div className={cx(styles.clockBig, runtime.remaining <= 3 && styles.clockWarning)}>
        {ss(runtime.remaining)}
      </div>
    </div>
  )
}
